<template>
  <v-data-table
    :dark="dark"
    :footer-props="{
      disableItemsPerPage: true,
    }"
    :headers="headers"
    :items="data"
    :items-per-page="pageItemLimit"
    :no-data-text="'No data available'"
    class="sourcery__table" />
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    pageItemLimit: {
      type: Number,
      default: 10,
    },
  },
};
</script>